"use client";
import { jsx as i, jsxs as n, Fragment as w } from "react/jsx-runtime";
import s from "clsx";
import C from "next/image";
import j from "next/link";
import { memo as v } from "react";
import { Box as h } from "../../base/Base.js";
import '../../../assets/CoinPack.css';const D = "_list_1c8xu_1", F = "__disabled_1c8xu_7", I = "_item_1c8xu_29", T = "__loading_1c8xu_42", q = "_image_1c8xu_59", z = "__active_1c8xu_75", A = "_friday_1c8xu_84", B = "_icon_coins_1c8xu_98", E = "_cost_1c8xu_101", G = "_badge_box_1c8xu_105", H = "_discount_1c8xu_113", J = "_hot_icon_1c8xu_122", K = "_coins_1c8xu_155", M = "_vip_1c8xu_163", O = "_free_1c8xu_166", Q = "_num_1c8xu_169", R = "_icon_1c8xu_98", c = {
  list: D,
  _disabled: F,
  item: I,
  _loading: T,
  image: q,
  _active: z,
  friday: A,
  icon_coins: B,
  cost: E,
  badge_box: G,
  discount: H,
  hot_icon: J,
  coins: K,
  vip: M,
  free: O,
  num: Q,
  icon: R
}, S = v(
  ({ disabled: o, children: _ }) => /* @__PURE__ */ i("div", { className: s(c.list, { [c._disabled]: o }), children: _ })
);
S.displayName = "CoinPackList";
const U = v(
  ({
    href: o,
    target: _,
    scroll: g = !1,
    onClick: t,
    hot: N,
    discount: a,
    imageBg: e,
    imageBgMeta: b,
    type: l = "vip",
    coins: k,
    coinsText: V,
    price: y,
    event: L = "none",
    active: P,
    loading: m,
    disabled: d,
    ...r
  }) => {
    const u = (f) => {
      if (m || d) {
        f.preventDefault();
        return;
      }
      t == null || t(f);
    }, x = s(c.item, c[L], {
      [c._active]: P,
      [c._loading]: m,
      [c._disabled]: d
    }), p = /* @__PURE__ */ n(w, { children: [
      e && /* @__PURE__ */ i(
        C,
        {
          src: e,
          className: c.image,
          alt: b || "",
          width: 202,
          height: 136
        }
      ),
      /* @__PURE__ */ n(h, { row: !0, className: c.badge_box, children: [
        a && a > 0 ? /* @__PURE__ */ n("span", { className: c.discount, children: [
          "-",
          a,
          "%"
        ] }) : null,
        N && /* @__PURE__ */ i(
          "span",
          {
            className: s("material-icons", c.hot_icon),
            "data-icon": "local_fire_department"
          }
        )
      ] }),
      /* @__PURE__ */ i("div", { className: c.cost, children: y }),
      /* @__PURE__ */ n(h, { gap: 4, row: !0, center: !0, className: s(c.coins, c[l]), children: [
        /* @__PURE__ */ i("div", { className: c.num, children: k }),
        /* @__PURE__ */ i(
          "div",
          {
            className: s("material-icons", c.icon),
            "data-icon": l === "vip" ? "diamond" : "star"
          }
        )
      ] })
    ] });
    return o ? /* @__PURE__ */ i(
      j,
      {
        href: o,
        target: _,
        scroll: g,
        className: x,
        onClick: u,
        ...r,
        children: p
      }
    ) : /* @__PURE__ */ i("div", { className: x, onClick: u, ...r, children: p });
  }
);
U.displayName = "CoinPack";
export {
  U as CoinPack,
  S as CoinPackList
};
